import {React, useState, useEffect} from 'react';
import styled from 'styled-components';
import PageTitle from '../partials/PageTitle';

const Contact = () => {
    const [emailParts, setEmailParts] = useState({ user: '', domain: '', tld: '' });
    const [showEmail, setShowEmail] = useState(false);

    useEffect(() => {
        // Obfuscate email by constructing it dynamically
        const user = ['c', 'o', 'n', 't', 'a', 'c', 't', '.', 'm', 'l', 's', 'v', 'd'].join('');
        const domain = ['g', 'm', 'a', 'i', 'l'].join('');
        const tld = ['c', 'o', 'm'].join('');

        setEmailParts({ user, domain, tld });
    }, []);

    const handleRevealEmail = () => {
        setShowEmail(true);
    };

    const getEmailLink = () => {
        if (emailParts.user && emailParts.domain && emailParts.tld) {
            return `mailto:${emailParts.user}@${emailParts.domain}.${emailParts.tld}`;
        }
        return '#';
    };

    return (
        <ContactContainer>
            <PageTitle page_title="Contact" />

            <ContentWrapper>
                <Description>
                    Feel free to reach out to me via email. I'll do my best to respond as soon as possible.
                </Description>

                {!showEmail ? (
                    <RevealButton onClick={handleRevealEmail}>
                        Click to reveal email address
                    </RevealButton>
                ) : (
                    <EmailDisplay>
                        <EmailLabel>Email:</EmailLabel>
                        <EmailLink href={getEmailLink()}>
                            <EmailPart>{emailParts.user}</EmailPart>
                            <EmailSymbol>&#64;</EmailSymbol>
                            <EmailPart>{emailParts.domain}</EmailPart>
                            <EmailSymbol>&#46;</EmailSymbol>
                            <EmailPart>{emailParts.tld}</EmailPart>
                        </EmailLink>
                        <EmailText>
                            <span>{emailParts.user}</span>
                            <span> [at] </span>
                            <span>{emailParts.domain}</span>
                            <span> [dot] </span>
                            <span>{emailParts.tld}</span>
                        </EmailText>
                    </EmailDisplay>
                )}
            </ContentWrapper>
        </ContactContainer>
    );
};

const ContactContainer = styled.div`
  padding: 4rem 0;
  max-width: 600px;
`;

const ContentWrapper = styled.div`
  margin-top: 2rem;
`;

const Description = styled.p`
  font-size: 1rem;
  color: var(--text-muted);
  margin-bottom: 2rem;
  line-height: 1.7;
`;

const RevealButton = styled.button`
  padding: 0.625rem 1.25rem;
  background: var(--bg-surface);
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: var(--font-sans);
  transition: border-color 0.15s, color 0.15s;

  &:hover {
    border-color: var(--accent);
    color: var(--accent);
  }
`;

const EmailDisplay = styled.div`
  padding: 1.5rem;
  background: var(--bg-surface);
  border-radius: 6px;
  border: 1px solid var(--border);
`;

const EmailLabel = styled.div`
  font-family: var(--font-mono);
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

const EmailLink = styled.a`
  display: inline-block;
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--text-primary);
  text-decoration: none;
  margin-bottom: 0.75rem;
  word-break: break-all;
  transition: color 0.15s;

  &:hover {
    color: var(--accent);
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const EmailPart = styled.span`
  display: inline;
`;

const EmailSymbol = styled.span`
  display: inline;
`;

const EmailText = styled.div`
  margin-top: 0.5rem;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  color: var(--text-muted);

  span {
    display: inline;
  }
`;

export default Contact;